import React from 'react';
import { styled } from 'linaria/react';
import LinkButton from './LinkButton';
import { theme } from '../../../Theme';

const OutsideWrapper = styled('div')`
  display: flex;
  justify-content: center;
`;

const Wrapper = styled('div')`
  width: 100%;
  max-width: 880px;
  display: flex;
  padding: 1rem 0;
  justify-content: ${props => props.position || 'center'};
  gap: 8px;
  ${theme.below.md} {
    padding: 16px;
  }
`;

const LinkButtons = ({ link_buttons, position }) => {
  return (
    <OutsideWrapper>
      <Wrapper position={position}>
        {link_buttons.map((item, index) => (
          <LinkButton
            key={item._uid}
            label={item.label}
            labelColor={item.label_color}
            theme={item.theme}
            link={item}
          />
        ))}
      </Wrapper>
    </OutsideWrapper>
  );
};

export default LinkButtons;
